import React, { AnchorHTMLAttributes } from 'react'
import { Icon } from '../Icons/Icon'
import { addProtocolIfMissing } from '../../../helpers/addProtocolIfMissing'

export const TagButton = ({
  label,
  iconName,
  isLink,
  onClick,
  href,
  target,
  needProtocol = true,
  rel,
} : {
  label: string
  iconName: string
  isLink: boolean
  needProtocol?: boolean
  onClick?: () => void
  href?: string
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target']
  rel?: AnchorHTMLAttributes<HTMLAnchorElement>['rel']
}) => {

  const Container = ({ children, className } : { children: React.ReactNode, className: string }) => (
    <>
      {isLink ? (
      <a href={href ? (needProtocol ? addProtocolIfMissing(href) : href) : ''} className={className} target={target} rel={rel}>
        {children}
      </a>
      ) : (
      <button className={className} onClick={onClick}>
        {children}
      </button>
      )}
    </>
  )

  return (
    <Container className='osirus-agent-tag-button'>
      <Icon iconName={iconName} />
      <p>{ label }</p>
    </Container>
  )
}
